import {
  CheckCircleFilled,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  PauseCircleOutlined,
  SettingOutlined,
  TruckOutlined,
} from '../../components/icons'
import type { IconKey } from './domain'

/**
 * Resolves the pure `IconKey` domain values (domain.ts) to the actual icon
 * component. Kept as a thin React-only seam so `domain.ts` itself stays
 * framework-free and unit-testable without a DOM.
 */
export function StatusIcon({ iconKey }: { readonly iconKey: IconKey }) {
  switch (iconKey) {
    case 'check-circle':
      return <CheckCircleOutlined aria-hidden="true" />
    case 'check-circle-filled':
      return <CheckCircleFilled aria-hidden="true" />
    case 'setting':
      return <SettingOutlined aria-hidden="true" />
    case 'truck':
      return <TruckOutlined aria-hidden="true" />
    case 'pause-circle':
      return <PauseCircleOutlined aria-hidden="true" />
    case 'close-circle':
      return <CloseCircleOutlined aria-hidden="true" />
    case 'clock-circle':
      return <ClockCircleOutlined aria-hidden="true" />
    default:
      return null
  }
}
